import Highcharts from 'highcharts';
import { chartColors } from '@/common/chart/chart-colors.js';

export const psHighchartsConfig: Highcharts.Options = {
    title: {
        text: 'Line chart title here',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    credits: {
        enabled: false,
    },
    subtitle: {
        text: 'Subtitle here (optional)',
        style: {
            color: 'var(--chart-layout-text-subtle)',
        },
    },
    xAxis: {
        type: 'datetime',
        title: {
            text: 'X axis label (optional)',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        tickPixelInterval: 200,
        tickLength: 0,
        startOfWeek: 0,
        dateTimeLabelFormats: {
            day: '%b %e',
            week: '%b %e',
            month: '%b %Y',
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
    },
    chart: {
        type: 'line',
        height: 600,
        backgroundColor: 'var(--chart-layout-background-base)',
        style: {
            fontFamily: 'Inter',
        },
        spacingTop: 20,
        spacingLeft: 0,
    },
    colors: chartColors,
    yAxis: {
        title: {
            text: 'Event count',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
            align: 'middle',
        },
        min: 0,
        gridLineColor: 'var(--chart-layout-gridline-base)',
        labels: {
            align: 'right',
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        tickPixelInterval: 92,
        allowDecimals: false,
        softMax: 1,
        max: undefined,
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: false,
            },
            enableMouseTracking: true,
            stickyTracking: true,
            accessibility: {
                keyboardNavigation: {
                    enabled: true,
                },
            },
            marker: {
                enabled: true,
            },
            showInLegend: true,
        },
    },
    series: [],
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const top10FeaturesByVisitorsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Features by Visitors',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--chart-layout-background-base)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Number of Visitors',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const top10PagesByVisitorsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Pages by Visitors',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--chart-layout-background-base)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Number of Visitors',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const top10FeaturesByEventsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Features by Events',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--chart-layout-background-base)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Number of Events',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const top10PagesByEventsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Pages by Events',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--chart-layout-background-base)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Number of Events',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const avgDailyTimeOnAppConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Average Daily Time on App',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    xAxis: {
        title: {
            text: 'Day',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        type: 'datetime',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Time in minutes',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};

export const avgWeeklyTimeOnAppConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Average Weekly Time on App',
        style: {
            color: 'var(--chart-layout-text-base)',
        },
    },
    xAxis: {
        title: {
            text: 'First day of week',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        type: 'datetime',
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    yAxis: {
        title: {
            text: 'Time in minutes',
            style: {
                color: 'var(--chart-layout-axis-title-base)',
            },
        },
        labels: {
            style: {
                color: 'var(--chart-layout-axis-label-base)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--chart-layout-gridline-base)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--chart-legend-text-base)',
        },
        itemHoverStyle: {
            color: 'var(--chart-legend-text-hover)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-chart-layout-tooltip-shadow-base), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--chart-layout-tooltip-background-base)',
        style: {
            color: 'var(--chart-layout-tooltip-text-base)',
        },
    },
};
